import store from 'Config/store'

export default function register() {
  //make sure that Service Workers are supported.
  if (navigator.serviceWorker && typeof BroadcastChannel !== 'undefined') {
    navigator.serviceWorker
      .register('/sw.js')
      .then(function(registration) {
        //console.log(registration)
        return registration.sync.register('sync-inventory-movements')
      })
      .catch(function(e) {
        /* eslint-disable */
        console.error(e)
        /* eslint-enable */
      })

    /*navigator.serviceWorker.addEventListener('message', event => {
      console.log(event.data)
      store.dispatch(event.data)
    })*/
    const channel = new BroadcastChannel('sync-channel')
    channel.onmessage = function(event) {
      //console.log(event.data)
      store.dispatch(event.data)
    }
  } else {
    /* eslint-disable */
    console.log('Service Worker is not supported in this browser.')
    /* eslint-enable */
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}



// WEBPACK FOOTER //
// ./src/registerServiceWorker.js